import pino from 'pino/browser'
import type {DomainsBaseStyles} from '../types'
import {DOMAIN_CONFIG_BY_HOSTNAME} from './hostname-to-config'

const browserLogConfig = {
  level: process.env.NODE_ENV === 'development' ? 'debug' : 'warn',
  browser: {
    asObject: true,
  },
}

const pinoLogger = pino(browserLogConfig)

type DomainConfigs = typeof DOMAIN_CONFIG_BY_HOSTNAME
type DomainNameFromHostname = ReturnType<DomainConfigs[keyof DomainConfigs]>['domainName']
type DomainTypeFromHostname = ReturnType<DomainConfigs[keyof DomainConfigs]>['domainType']
export interface DomainConfig {
  domainName: DomainNameFromHostname
  domainType: DomainTypeFromHostname
  measurementId: string
  camelCaseUrl: string
  siteName: string
  title: (category: string, count: string) => string
  description: (category?: string, count?: string) => string
  logo: JSX.Element
  favicon: string
  styles: DomainsBaseStyles
}

export function getDomainConfig(hostname: string, locale: string = 'us'): DomainConfig {
  const normalizedLocale = locale.toLowerCase()
  const createConfigByLocale =
    DOMAIN_CONFIG_BY_HOSTNAME[hostname as keyof typeof DOMAIN_CONFIG_BY_HOSTNAME] ??
    DOMAIN_CONFIG_BY_HOSTNAME['www.bestreviews.guide']
  const domainConfig = createConfigByLocale(normalizedLocale) ?? createConfigByLocale('us')
  if (!domainConfig) {
    pinoLogger.warn({hostname, locale: normalizedLocale}, 'No domain configuration available')
  }
  return domainConfig
}
